export function commonAttributes(objects, defaultValue = null, keySpecificDefaultValue = {}) {
  if (objects.length === 0) return {};

  const keys = new Set(objects.flatMap(obj => Object.keys(obj)));

  const result = {};

  for (const key of keys) {
    const firstValue = objects[0][key];
    const allSame = objects.every(obj => obj[key] === firstValue);

    result[key] = allSame ? firstValue :
      Object.hasOwn(keySpecificDefaultValue, key) ? keySpecificDefaultValue[key] : defaultValue;
  }

  return result;
}

export function transferAttributes(targetObj, sourceObj, except = []){
  for(const [k, v] of Object.entries(sourceObj)) {
    if(except.includes(k)) continue
    targetObj[k] = v
  }
}

const frzName = [
  [`leftdia`, `frzLdia`], [`rightdia`, `frzRdia`],
  [`left`, `frzLeft`], [`down`, `frzDown`], [`up`, `frzUp`], [`right`, `frzRight`],
  [`space`, `frzSpace`], [`iyo`, `frzIyo`], [`gor`, `frzGor`], [`oni`, `foni`],
]

export function danoniGetFrzName(arrowName) {
  arrowName = frzName.reduce((a, x) => a.split(x[0]).join(x[1]), arrowName)

  if (arrowName.indexOf(`frz`) === -1 && arrowName.indexOf(`foni`) === -1) {
    arrowName = arrowName.replaceAll(arrowName, `frz${arrowName.charAt(0).toUpperCase()}${arrowName.slice(1)}`);
  }
  return arrowName
}

export function danoniGetArrowName(frzArrowName) {
  frzArrowName = [...frzName]
    .reverse()
    .reduce((a, [normal, frozen]) => a.split(frozen).join(normal), frzArrowName);

  if (frzArrowName.startsWith("frz")) {
    frzArrowName =
      frzArrowName.charAt(3).toLowerCase() + frzArrowName.slice(4);
  }

  return frzArrowName;
}

function approximateFraction(x, maxDen = 128) {
  let h1 = 1, h0 = 0;
  let k1 = 0, k0 = 1;
  let b = x;

  do {
    const a = Math.floor(b);
    let h2 = a * h1 + h0;
    let k2 = a * k1 + k0;

    if (k2 > maxDen) break;

    h0 = h1; h1 = h2;
    k0 = k1; k1 = k2;

    b = 1 / (b - a);
  } while (Math.abs(x - h1 / k1) > 1e-10);

  return [h1, k1];
}

export function timeToFraction(bpm, time, maxDen = 128) {
  const beatsElapsed = (time * bpm) / 60;
  return approximateFraction(beatsElapsed, maxDen);
}